import React, { useEffect } from 'react';
import {
  ATMInput,
  ATMDropdown,
  ATMField,
  ATMForm,
  ATMGrid,
} from 'shared-it-appmod-ui';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';
import Lang from 'src/libraries/language';
import { useDistrictContext } from 'src/contexts/district.context';
import { DistrictSchema } from 'src/models/district.model';
import { DistrictType } from 'src/constants';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
  editIsOpen: boolean;
  company: (data) => void;
  companyName: string;
};

const DistrictForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
  company,
  companyName,
  editIsOpen,
}) => {
  const { actions: districtAction } = useDistrictContext();

  useEffect(() => {
    districtAction.listGET();
  }, [districtAction]);

  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={DistrictSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="equal">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_DISTRICT_SDGE_CONTRACTOR}
                    name="relationship"
                    control={control}
                    as={ATMDropdown}
                    placeholder={Lang.LBL_ENTER}
                    onChange={([_, { value }]) => {
                      company(value);
                      return value;
                    }}
                    options={[
                      { key: '0', text: 'SCG', value: DistrictType.Company },
                      {
                        key: '1',
                        text: DistrictType.Contractor,
                        value: DistrictType.Contractor,
                      },
                    ]}
                    clearable={!editIsOpen}
                    required
                    search
                    selection
                    fluid
                    error={errors.relationship}
                  />
                  <ATMField
                    key={companyName}
                    label={
                      <LabelRequired>
                        {companyName === DistrictType.Company
                          ? Lang.LBL_DISTRICT_NAME
                          : Lang.LBL_PROJECT_NAME}
                      </LabelRequired>
                    }
                    name="value"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    error={errors.value}
                    onChange={([_, { value }]) => value}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default DistrictForm;
